import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { BillingEntity } from 'src/features/billingEntity/utils/types';
import { BillingEntityFormSchemaValues } from 'src/features/billingEntity/utils/formSchema';

const RESOURCE = `sp-core/:parkingId/billing/billing-entities/:billingEntityId/`;

type MutationFnType = typeof mutationFn;

interface DTO extends BillingEntityFormSchemaValues {
    parkingId: string;
    billingEntityId: string;
}
const mutationFn = ({ parkingId, billingEntityId, ...data }: DTO): Promise<BillingEntity> => {
    return axios.put(formatResourcePath(RESOURCE, { parkingId, billingEntityId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateBillingEntity };
